import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import AddmissionButton from 'layouts/AccountingSessions/AddmissionButton';
import React from 'react'
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import SessionsApi from '../../../../Classes/API/Administration/SessionsApi';
import SearchStringOrIntReq from '../../../../Classes/Models/Requests/SearchStringOrIntReq';


const ConfirmedAppointmentBox = ({ Appointment }) => {
    let navigate = useNavigate();
    const ToggleSessionAdmission = async (AccSession) => {
        let req = new SearchStringOrIntReq();
        req.SearchInt = AccSession.id;

        let res = await SessionsApi.ToggleAccountingSessionAdmission(req);

        if (res.status == "Success") {
            Swal.fire("Success", res.message, "success");

            window.location.reload();
        }
        else {
            Swal.fire("Failed", res.message, "error");
        }
    }

    const GoToAccSessionDetails = (AccSession) => {
        navigate(
            '/AccountingSessions/Details',
            {
                state: {
                    SearchSession: AccSession,
                }
            }
        )
    }
    return (
        <>
            <MDTypography
                onClick={() => GoToAccSessionDetails(Appointment.getAccountingSession)}
                className="custom-card">
                <span class="badge badge-success">Confirmed: {Appointment.getPatient.getUser.name}, {Appointment.getAccountingSession.sessionName}</span>
            </MDTypography>

            <MDBox py={1} pr={2}>
                <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                    Addmission:
                </MDTypography>
                <AddmissionButton AccSession={Appointment.getAccountingSession} />
                {/* <MDTypography variant="button" fontWeight="regular" color="text">
                    &nbsp;
                    {Appointment.getAccountingSession.isPaidFor ? (
                        <>
                            {Appointment.getAccountingSession.isAdmitted ? (
                                <>
                                    <span class="badge badge-success">ADMITTED</span>
                                    <br />
                                    <button onClick={() => ToggleSessionAdmission(Appointment.getAccountingSession)} className="btn btn-warning">UnAddmit</button>
                                </>)
                                : (<>
                                    <span class="badge badge-danger">NOT ADMITTED</span>
                                    <br />
                                    <button onClick={() => ToggleSessionAdmission(Appointment.getAccountingSession)} className="btn btn-success">Addmit</button>
                                </>)}
                        </>
                    ) : (
                        <button disabled={true} className="btn btn-danger">Session Not Paid</button>
                    )}
                </MDTypography> */}
            </MDBox>



        </>
    )
}

export default ConfirmedAppointmentBox